import script from "./SignUp.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUp.vue?vue&type=script&setup=true&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=3692b6aa&scope=true&lang=css"

const __exports__ = script;

export default __exports__